import { useEffect, useState } from "react";


import {
  getNewsPost
} from "../api/wordpressNews.api";


export const useNewsPost = (postId) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    if (!postId) {
      return;
    }

    const controller = new AbortController();


    const loadPost = async () => {
      try {
        setLoading(true);
        setError(null);

        const data = await getNewsPost({
          postId,
          signal: controller.signal
        });

        if (!controller.signal.aborted) {
          setPost(data);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error(err);

          setError(err);
          setPost(null);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };


    loadPost();


    return () => {
      controller.abort();
    };
  }, [postId]);


  return {
    post,
    loading,
    error
  };
};